<h4 class="sol-no-result-title" data-test="sol-no-result-title">{{ title }}</h4>
<p *ngIf="subtitle" class="sol-no-result-subtitle" data-test="sol-no-result-subtitle">
  {{ subtitle }}
</p>
